import { ButtonIcon } from '@framework/ui';
import { ButtonProps } from 'antd/lib/button';
import clx from 'classnames';
import React from 'react';
import styled from 'styled-components';

const MenuButtonIcon = styled(ButtonIcon)`
  display: flex;
  flex: 0 0 auto;
  min-width: 0;
  justify-content: center;
  align-items: center;
  /* margin-right: 5px; */
  color: ${props => props.theme.colorTextSecondary};
  &:active,
  &:focus {
    color: ${props => props.theme.colorTextSecondary};
  }
  &.negative.ant-btn {
    &:hover {
      background-color: ${props => props.theme.colorPrimaryActive};
    }
    &:focus-visible {
      outline: 2px solid ${props => props.theme.focusOutlineNegativeColor} !important;
      outline-offset: 0px;
      transition: all 0.3s, visibility 0.3s;
    }
  }
  &.negative {
    .anticon,
    .ant-badge {
      color: ${props => props.theme.colorBgContainer};
    }
  }
`;

export interface ITopMenuIconButtonProps extends Omit<ButtonProps, 'type'> {
  theme?: 'positive' | 'negative';
}

export function TopMenuIconButton(props: ITopMenuIconButtonProps) {
  const { theme = 'negative', className, ...buttonProps } = props;
  return (
    <MenuButtonIcon
      className={clx(className, { negative: theme == 'negative' })}
      {...buttonProps}
    />
  );
}
